<template>
  <div class="remind">
    <el-dialog
      title="天气提醒"
      :visible.sync="params.flag"
      v-dialogDrag
      :modal="false"
      :close-on-click-modal="false"
      :lock-scroll="false"
      :modal-append-to-body="false"
      ref="remRef"
      :before-close="
        () => params.flag && $parent.toggleProductView(params.productInfo.code)
      "
    >
      <div class="search">
        <div class="datetime">
          <label>起止时间：</label>
          <el-date-picker
            v-model="datetime"
            type="datetimerange"
            range-separator="至"
            start-placeholder="开始日期"
            end-placeholder="结束日期"
            value-format="timestamp"
            :append-to-body="false"
          >
          </el-date-picker>
        </div>
        <div class="keywords">
          <i></i><input v-model="keywords" placeholder="请输入关键字" />
        </div>
        <div class="search-btn">
          <button @click="searchbtnClcik">搜索</button>
          <el-button
            @click="handleDownload"
            type="parmary"
            style="margin-left: 0.84vw"
            >下载</el-button
          >
        </div>
      </div>
      <div class="list">
        <div class="list-wrap">
          <el-table :data="tableData" height="90%" style="width: 100%">
            <el-table-column prop="crttimeFmt" label="发布时间" width="150px">
              <template slot-scope="scope">
                {{ scope.row.crttimeFmt.slice(0, -3) }}
              </template>
            </el-table-column>
            <!-- <el-table-column prop="objname" label="项目名称" width="180px">
            </el-table-column> -->
            <el-table-column prop="cont" label="消息内容"> </el-table-column>
            <el-table-column label="操作" width="80px">
              <template slot-scope="scope">
                <img
                  src="../assets/images/更多.png"
                  @click="showMoreDetail(scope.row)"
                  alt=""
                  class="image"
                />
              </template>
            </el-table-column>
          </el-table>
          <el-pagination
            @size-change="handleSizeChange"
            @current-change="handleCurrentChange"
            :current-page.sync="currentPage"
            :page-size="pageSize"
            layout="total, prev, pager, next"
            :total="total"
          >
          </el-pagination>
        </div>
      </div>
    </el-dialog>

    <more-detail
      ref="tqdRed"
      title="天气提醒详情"
      width="40%"
      :detailDialogVisible="detailDialogVisible"
      :morDetailConfig="morDetailConfig"
      :detailData="detailData"
      @changeDialogVisible="detailDialogVisible = false"
    >
    </more-detail>
  </div>
</template>
<script>
import MoreDetail from "./module/MoreDetail.vue";
import { handleDownload } from "@/utils/exportFile";
import { apiData } from "../api/index";
export default {
  name: "Remind",
  props: ["params"],
  data() {
    return {
      dialogTableVisible: false,
      total: 0,
      currentPage: 1,
      pageSize: 10,
      tableData: [],
      datetime: "",
      keywords: "",
      rootFontSize: window.rootFontSize,
      detailDialogVisible: false,
      detailData: {},
      morDetailConfig: [
        { label: "标题", field: "title" },
        // { label: "项目名称", field: "objname" },
        { label: "提醒内容", field: "cont" },
        // { label: '发布人', field: 'username' },
        // { label: '发布时间', field: 'crttimeFmt' }
      ],
    };
  },
  watch: {
    "params.flag": {
      handler(flag) {
        flag && this.setZindex();
      },
      immediate: true,
    },
  },
  created() {
    this.initData();
    this.queryTxMsg();
  },
  methods: {
    // 初始化数据
    initData() {
      const currentTime = new Date().getTime();
      const startTime = currentTime - 86400000 * 60;
      const endTime = currentTime;
      this.datetime = [startTime, endTime];
    },
    async queryTxMsg() {
      if (!this.datetime) {
        this.$message.error("天气时间不能为空!");
        return;
      }
      const company = this.$route.params.company;
      const unitid = JSON.parse(localStorage.getItem(company)).unit.id;
      const params = {
        keyword: this.keywords,
        unitid: unitid,
        page: this.currentPage,
        pagesize: this.pageSize,
        stime: this.datetime[0],
        etime: this.datetime[1],
      };
      const result = await apiData.queryTxMsg(params);
      if (result.status === 200) {
        this.tableData = result.data.datas;
        this.total = result.data.rows;
      }
    },
    searchbtnClcik() {
      this.queryTxMsg();
      this.keywords = "";
    },
    showMoreDetail(data) {
      this.detailData = data;
      this.detailDialogVisible = true;
      this.$nextTick(() => {
        this.$refs.tqdRed.setZindex();
      });
    },

    handleDownload() {
      const filterVal = ["crttimeFmt", "objname", "cont"];
      const header = ["发布时间", "项目名称", "消息内容"];
      handleDownload(filterVal, this.tableData, header, "天气提醒");
    },

    handleSizeChange(pageSize) {
      this.pageSize = pageSize;
      this.queryTxMsg();
    },
    handleCurrentChange(currentPage) {
      this.currentPage = currentPage;
      this.queryTxMsg();
    },
    // 设置弹出框的zIndex
    setZindex() {
      this.$nextTick(() => {
        const el = this.$refs.remRef;
        let zIndex = JSON.parse(localStorage.getItem("dialogZIndex"));
        zIndex = zIndex * 1 + 1;
        el.$el.style.zIndex = zIndex;
        localStorage.setItem("dialogZIndex", JSON.stringify(zIndex));
      });
    },
  },
  components: {
    MoreDetail,
  },
};
</script>
<style lang="less" scoped>
.remind {
  pointer-events: none;
  .search {
    display: flex;
    justify-content: space-between;
    align-items: center;
    margin-bottom: 0.78vw;

    .datetime {
      label {
        font-size: 1rem;
        font-weight: 600;
        color: #fff;
      }

      /deep/.el-range-editor.el-input__inner {
        height: 2.5rem;
        line-height: 2.5rem;
        width: 25rem;
        background: #0c4170;
        border: 1px solid #52607f;

        .el-range__icon {
          line-height: 2.5rem;
          height: 2.5rem;
        }

        .el-range-separator {
          line-height: 2.5rem;
          height: 2.5rem;
          font-size: 1rem;
          color: #fff;
        }

        .el-range-input {
          font-size: 0.88rem;
          color: #fff;
          background: #0c4170;
        }
      }
    }

    .keywords {
      width: 30rem;
      height: 2.5rem;
      border-radius: 0.38rem;
      background: #0c4170;
      border: 1px solid #52607f;
      display: flex;
      align-items: center;

      i {
        display: inline-block;
        width: 1.13rem;
        height: 1.06rem;
        background: url("../assets/images/搜索.png") no-repeat;
        background-size: contain;
        margin: 0 0.44rem 0 1rem;
      }

      input {
        height: 2.5rem;
        flex: 1;
        border-radius: 0.38rem;
        border: 0;
        font-size: 0.88rem;
        color: #fff;
        outline: none;
        padding: 0 1rem 0 0;
        background: #0c4170;
      }
    }

    .search-btn {
      button {
        width: 4.31rem;
        height: 2.44rem;
        background: linear-gradient(204deg, #59acfb 0%, #2d74f5 100%);
        border-radius: 0.38rem;
        border: 0;
        cursor: pointer;
        font-size: 0.88rem;
        color: #ffffff;
      }
    }
  }
  .list {
    flex: 1;
    position: relative;
    .list-wrap {
      position: absolute;
      left: 0;
      top: 0;
      right: 0;
      bottom: 0;
      .el-table {
        background: transparent;
        text-align: center;

        /deep/ tr {
          background: transparent;
          th {
            text-align: center;
            border: 0;
            font-size: 0.88rem;
            font-weight: 600;
            color: #fff;
            background: #0c4170;
          }
          td {
            text-align: center;
            font-size: 0.88rem;
            font-weight: 400;
            color: #fff;
            border-bottom: 1px solid #316ea3;
          }
          .print {
            width: 1.13rem;
            height: 1.13rem;
            background: url("../assets/images/打印.png") no-repeat;
            border: 0;
            cursor: pointer;
            background-size: 1.13rem 1.13rem;
          }
          .image {
            margin: 0.52vw;
            width: 1.09vw;
            cursor: pointer;
          }
        }
        /deep/ tr:hover td {
          background: #0c4170 !important;
        }

        .new {
          margin-left: 0.52vw;
          background-color: #f56c6c;
          border-radius: 0.32vw;
          color: #fff;
          display: inline-block;
          font-size: 0.43vw;
          height: 0.94vw;
          line-height: 0.94vw;
          padding: 0.1vw 0.31vw;
          text-align: center;
          white-space: nowrap;
        }

        /deep/.el-table__body-wrapper::-webkit-scrollbar {
          width: 6px;
          height: 6px;
        }
        /deep/.el-table__body-wrapper::-webkit-scrollbar-thumb {
          border-radius: 5px;
          background: #273458;
        }

        /deep/.el-table__body-wrapper::-webkit-scrollbar-thumb:hover {
          border-radius: 5px;
          box-shadow: inset 0 0 5px rgba(0, 0, 0, 0.2);
          background: #1b2230;
        }

        /deep/.el-table__body-wrapper::-webkit-scrollbar-track {
          border-radius: 5px;
          background: #0c4170;
        }
        /deep/.el-table__fixed-right-patch {
          background: #1b3b80;
          border: 0;
        }
      }

      .el-pagination {
        display: flex;
        justify-content: flex-end;
        align-items: center;
        /deep/ .el-pager li {
          background: transparent;
          color: #fff;
        }
        /deep/ .el-pager li.active {
          color: #6fbeff;
        }
        /deep/ .el-pagination__total {
          color: #fff;
        }
        /deep/ .btn-prev,
        .btn-next {
          background: transparent;
          color: #fff;
        }
        /deep/ .btn-next {
          background: transparent;
          color: #fff;
        }
        /deep/ .el-icon {
          color: #afa7a7;
        }
      }
      .el-table::before {
        background: transparent;
      }
      .el-icon-more {
        color: blue;
        font-size: 0.94vw;
        cursor: pointer;
      }
    }
  }
  /deep/.el-dialog__wrapper {
    overflow: hidden;
    .el-dialog {
      pointer-events: auto;
    }
  }
}

/deep/ .el-input__inner {
  background: #25324d;
  border: 1px solid #52607f;
  color: #fff;
}
/deep/ .el-input__inner::placeholder {
  color: #fff;
}
/deep/ input::placeholder {
  color: #fff;
}
</style>
